import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../../auth/auth.service';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Constant } from '../../constant';
import { MasterItem } from '../../model/my-event';

@Component({
  selector: 'app-my-event-create-dialog',
  templateUrl: './my-event-create-dialog.component.html',
  styleUrl: './my-event-create-dialog.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ]
})
export class MyEventCreateDialogComponent implements OnInit {
  public readonly Constant = Constant;
  public title = '';
  public categoryId: number | null = null;
  public categoryOptions: MasterItem[] = [];
  public showSpinner = false;
  public maxTitleLength = 50;

  constructor(
    private dialogRef: MatDialogRef<MyEventCreateDialogComponent>,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
  ) {}

  ngOnInit() {
    this.loadMasterData();
  }

  // タイトルの文字数
  get titleLength(): number {
    return this.title.length;
  }

  // タイトルが超過しているか
  get isTitleOverLimit(): boolean {
    return this.titleLength > this.maxTitleLength;
  }

  // 作成ボタンが有効か
  get isCreateButtonEnabled(): boolean {
    return this.title.trim().length > 0 &&
           !this.isTitleOverLimit &&
           this.categoryId !== null &&
           !this.showSpinner;
  }

  // キャンセル
  onCancel(): void {
    this.dialogRef.close();
  }

  // 作成
  onCreate(): void {
    if (!this.isCreateButtonEnabled) {
      return;
    }

    if (!this.commonUtil.checkOnline()) {
      return;
    }

    this.showSpinner = true;

    Auth.currentSession().then(session => {
       const options = this.auth.createApiHeader(session);
       options['body'] = {
         title: this.title,
         categoryId: this.categoryId,
       };
       this.commonUtil.apiPost('/myevent', options)
       .then(res => {

        if (res.status === Constant.OK) {
          this.toastUtil.showInformationToast(
            '',
            Constant.msgNoticeNew,
            Constant.toastShowMiliSec
          );
          this.dialogRef.close({
            success: true,
            eventId: res.data.event_id,
            title: this.title,
            categoryId: this.categoryId,
          });
        } else {
          this.showSpinner = false;
          if (res.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
          }
        }
      })
      .catch(err => {
        this.showSpinner = false;
        this.commonUtil.debug().log(err);
        this.toastUtil.showErrorToast(
          '',
          Constant.msgSaveFailedRetry,
          Constant.toastShowMiliSec
        );
      });

    }).catch(err => {
      this.showSpinner = false;
      this.commonUtil.debug().log(err);
      this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
    });
  }

  // カテゴリーマスタ取得
  private loadMasterData(): void {
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      return this.commonUtil.apiGet('/myevent/master', options);
    }).then(res => {
      this.categoryOptions = res.data['category_major'] ?? [];
    }).catch(err => {
      this.commonUtil.debug().log(err);
    });
  }
}
